import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
export const setupOptionStyle = {
    colSize: {
        default: { size: "12" },
        retro: { size: "2" }, electric: { size: "2" }
    },
    colStyle: {
        default: { padding: "0" },
        retro: { padding: "0", margin: "2px", display: "inline-block", width: "auto", boxShadow: "none" },
        electric: { padding: "0", margin: "2px", display: "inline-block", width: "auto", boxShadow: "none" }
    }
}



// WEBPACK FOOTER //
// ./src/components/SetupPage/style/SetupOptions.js